import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import DayService from "../../../../services/catalogs/DayService";

export const REQUEST_DELETE_DAY = "REQUEST_DELETE_DAY";
export const DELETE_DAY_SUCCESS = "DELETE_DAY_SUCCESS";
export const DELETE_DAY_ERROR = "DELETE_DAY_ERROR";

function requestDeleteDay() {
  return {
    type: REQUEST_DELETE_DAY,
  };
}

function deleteDaySuccess(json) {
  return {
    type: DELETE_DAY_SUCCESS,
    message: json.data,
  };
}

function deleteDayError(json) {
  return {
    type: DELETE_DAY_ERROR,
    error: json.data,
  };
}

export function deleteDay(day_id) {
  return (dispatch) => {
    dispatch(requestDeleteDay());
    return DayService.deleteDay(day_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(deleteDaySuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(deleteDay(day_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(deleteDayError(json.data));
      }
    });
  };
}
